import React from "react";

import GlyphButton from "./GlyphButton";
import GlyphIcons from "../../common/constants/GlyphIcons";
import TextButton from "./TextButton";
import TooltipIcon from "./TooltipIcon";
import Item from "../../layers/dto/Item";

import { IntlContextProvider, IntlContext } from "../../core/core-widgets/contexts/IntlContext";

const ITEM_BUTTON_CLASS_NAME = "itemButton";
const HIDE_BUTTON_CLASS_NAME = "hideButton";
const ADD_BUTTON_CLASS_NAME = "addButton";
const ITEM_TEXT_CLASS_NAME = "itemText";
const REMOVE_BUTTON_CLASS_NAME = "removeButton";
const LAYER_ITEM_CLASS_NAME = "layerItem";

interface LayerItemProps {
    item: Item;
    className: string;
    itemVisible: boolean;
    itemExpanded?: boolean;
    onHide?: false | ((filterId: number, visibility: boolean) => void);
    onAdd?: ((filterId: string) => void) | (() => void) | null;
    onRemove?: false | ((filterId: number) => void);
    onClick?: ((itemId: string | number, boolParameter?: boolean) => void) | null;
    onExpand?: (itemId: string, expand: boolean) => void;
    onRefresh?: false | (() => void);
}

const LayerItem = (props: LayerItemProps) => {
    const warning = props.item && props.item.warning;
    return (
        <IntlContextProvider>
            <IntlContext.Consumer>
                {({ intl }) => {
                    return (
                        <div
                            id={`${props.className}${props.item.id}`}
                            className={`${LAYER_ITEM_CLASS_NAME} ${props.className} ${
                                warning ? "layerItemWarning" : ""
                            }`}
                            key={props.item.id}
                        >
                            <GlyphButton
                                id={HIDE_BUTTON_CLASS_NAME + props.item.id}
                                itemId={props.item.id}
                                onClick={props.onHide ? props.onHide : null}
                                className={`${ITEM_BUTTON_CLASS_NAME} ${HIDE_BUTTON_CLASS_NAME}`}
                                glyph={props.itemVisible ? GlyphIcons.EYE_OPEN : GlyphIcons.EYE_CLOSE}
                                boolParameter={props.itemVisible}
                                tooltip={intl.formatMessage({ id: "layersPlugin.layerItem.toggleVisibility" })}
                            />
                            <TextButton
                                id={ITEM_TEXT_CLASS_NAME + props.item.id}
                                className={ITEM_TEXT_CLASS_NAME}
                                onClick={props.onClick}
                                itemId={props.item.id}
                                messageKey={props.item.messageKey}
                                text={props.item.name}
                            />
                            <TooltipIcon
                                id={"warning" + props.item.id}
                                className={`${ITEM_BUTTON_CLASS_NAME} warning`}
                                tooltip={warning}
                                glyph={GlyphIcons.WARNING}
                            />
                            <GlyphButton
                                id={ADD_BUTTON_CLASS_NAME + props.item.id}
                                itemId={props.item.id}
                                onClick={props.onAdd ? props.onAdd : null}
                                className={`${ITEM_BUTTON_CLASS_NAME} ${ADD_BUTTON_CLASS_NAME}`}
                                glyph={GlyphIcons.PLUS}
                                tooltip={intl.formatMessage({ id: "layersPlugin.layerItem.addItem" })}
                            />
                            <GlyphButton
                                id={REMOVE_BUTTON_CLASS_NAME + props.item.id}
                                itemId={props.item.id}
                                onClick={props.item.removable && props.onRemove ? props.onRemove : null}
                                className={`${ITEM_BUTTON_CLASS_NAME} ${REMOVE_BUTTON_CLASS_NAME}`}
                                glyph={GlyphIcons.REMOVE}
                                tooltip={intl.formatMessage({ id: "layersPlugin.layerItem.removeItem" })}
                            />
                            <GlyphButton
                                id={"expand" + props.item.id}
                                itemId={props.item.id}
                                onClick={props.onExpand ? props.onExpand : null}
                                className={`${ITEM_BUTTON_CLASS_NAME} expand`}
                                glyph={props.itemExpanded ? GlyphIcons.FOLDER_OPEN : GlyphIcons.FOLDER_CLOSE}
                                boolParameter={props.itemExpanded}
                                tooltip={
                                    props.itemExpanded
                                        ? intl.formatMessage({ id: "layersPlugin.layerItem.closeGroup" })
                                        : intl.formatMessage({ id: "layersPlugin.layerItem.openGroup" })
                                }
                            />
                            <GlyphButton
                                id={"refresh" + props.item.id}
                                itemId={props.item.id}
                                onClick={props.onRefresh ? props.onRefresh : null}
                                className={`${ITEM_BUTTON_CLASS_NAME} refresh`}
                                glyph={GlyphIcons.REFRESH}
                                tooltip={intl.formatMessage({ id: "layersPlugin.layerItem.refreshItems" })}
                            />
                        </div>
                    );
                }}
            </IntlContext.Consumer>
        </IntlContextProvider>
    );
};

export default LayerItem;
